<template>
    <div class="d-flex flex-column flex-grow-1 collapse-main-base-scv overflow-auto default-text-font"
        style="height: 0px;">
        <div>
            <!-- 制限設定 -->
            <AlertSettingItem alertSettingName="制限設定" targetDialog="limitSetting"
                @onSettingCheckButton="onSettingCheckButton" :requiredSetting="0"
                :enableSetting="(editiongPolicy.skypolicy.limitSettingEnabled) ? 1 : 0"
                :informationHtml=limitSettingInformationHtml() />
            <div id="collapselimitSetting" class="collapse collapse-main-area-scv">
                <AndroidLimitSetting ref="limitSetting" @notifyUpdate="onNotifyUpdate"
                    v-bind:disabled="!editiongPolicy.skypolicy.limitSettingEnabled" />
            </div>

        </div>
        <div>
            <!-- パスワード設定 -->
            <AlertSettingItem alertSettingName="画面ロック設定" targetDialog="passwordSetting"
                @onSettingCheckButton="onSettingCheckButton" :requiredSetting="0"
                :enableSetting="(editiongPolicy.skypolicy.passwordSettingEnabled) ? 1 : 0" />
            <div id="collapsepasswordSetting" class="collapse collapse-main-area-scv">
                <AndroidPasswordSetting ref="passwordSetting" @notifyUpdate="onNotifyUpdate"
                    v-bind:disabled="!editiongPolicy.skypolicy.passwordSettingEnabled" />
            </div>
        </div>
        <div>
            <!-- ネットワーク設定 -->
            <AlertSettingItem alertSettingName="ネットワーク設定" targetDialog="networkSetting"
                @onSettingCheckButton="onSettingCheckButton" :requiredSetting="0"
                :enableSetting="(editiongPolicy.skypolicy.networkSettingEnabled) ? 1 : 0" />
            <div id="collapsenetworkSetting" class="collapse collapse-main-area-scv">
                <AndroidNetworkSetting ref="networkSetting" @notifyUpdate="onNotifyUpdate"
                    v-bind:disabled="!editiongPolicy.skypolicy.networkSettingEnabled" />
            </div>
        </div>
        <div>
            <!-- OS設定 -->
            <AlertSettingItem alertSettingName="システムアップデート設定" targetDialog="osSetting"
                @onSettingCheckButton="onSettingCheckButton" :requiredSetting="0"
                :enableSetting="(editiongPolicy.skypolicy.osSettingEnabled) ? 1 : 0" />
            <div id="collapseosSetting" class="collapse collapse-main-area-scv">
                <AndroidOSSetting ref="osSetting" @notifyUpdate="onNotifyUpdate"
                    v-bind:disabled="!editiongPolicy.skypolicy.osSettingEnabled" />
            </div>
        </div>
        <div v-if="isManagedGoogleDomain">
            <!-- Googleアカウント認証設定 -->
            <AlertSettingItem alertSettingName="端末利用時のGoogleアカウント設定" targetDialog="googleAccountSetting"
                :requiredSetting="1"
                :informationHtml=ManagedGoogleDomainInformationHtml() />
            <div id="collapsegoogleAccountSetting" class="collapse collapse-main-area-scv">
                <AndroidGoogleAccountSetting ref="googleAccountSetting" @notifyUpdate="onNotifyUpdate"
                    v-bind:disabled="false" :isManagedGoogleDomain="isManagedGoogleDomain" :onPremises="onPremises" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options } from 'vue-class-component';
import { cloneDeep } from 'lodash';
import AbstractSettingTab from '@/components/AbstractSettingTab';
import AlertSettingItem from '@/components/Alert/AlertSettingItem.vue';
import AndroidLimitSetting from '@/views/Mobile/Android/AndroidLimitSetting.vue'
import AndroidPasswordSetting from '@/views/Mobile/Android/AndroidPasswordSetting.vue'
import AndroidNetworkSetting from '@/views/Mobile/Android/AndroidNetworkSetting.vue'
import AndroidOSSetting from '@/views/Mobile/Android/AndroidOSSetting.vue'
import AndroidGoogleAccountSetting from '@/views/Mobile/Android/AndroidGoogleAccountSetting.vue';
import { AndroidPolicyWrapper } from '@/models/Mobile/Android/AndroidPolicyWrapper'
import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'
import { MessageUtil } from '@/models/Message/MessageUtil';
import * as schemaConstants from '@/models/Mobile/Android/AndroidManagementV1SchemaConstants'

@Options({
    props: {
        isManagedGoogleDomain: {
            type: Boolean,
            default: false,
            required: false,
        },
        onPremises: {
            type: Boolean,
            required: true,
        }
    },
    components: {
        AlertSettingItem,
        AndroidLimitSetting,
        AndroidPasswordSetting,
        AndroidNetworkSetting,
        AndroidOSSetting,
        AndroidGoogleAccountSetting,
    },
    emits: [
        'notifyUpdate'
    ]
})

export default class SettingCommonForAndroid extends AbstractSettingTab {
    // SKYSEA MDMアプリ設定
    private readonly isManagedGoogleDomain!: boolean;

    // 編集中のポリシー
    private editiongPolicy = new AndroidPolicyWrapper();

    /**
     *  ポリシーJSON文字列をセット
     */
    public setPolicyJsonText(jsonText: string): void {
        var tmp = Object.assign(new AndroidPolicyWrapper, JSON.parse(jsonText));

        // SkyPolicyのチェック状態が未定義なら明示的に入れる
        if (undefined == tmp.skypolicy.limitSettingEnabled) {
            tmp.skypolicy.limitSettingEnabled = false;
        }
        if (undefined == tmp.skypolicy.passwordSettingEnabled) {
            tmp.skypolicy.passwordSettingEnabled = false;
        }
        if (undefined == tmp.skypolicy.networkSettingEnabled) {
            tmp.skypolicy.networkSettingEnabled = false;
        }
        if (undefined == tmp.skypolicy.osSettingEnabled) {
            tmp.skypolicy.osSettingEnabled = false;
        }

        // 非推奨設定を推奨設定にコンバートする。
        this.editiongPolicy = AndroidPolicyWrapper.convertDeprecatedPolicy(tmp);

        // 子コンポーネントに参照をセット
        const refObj: any = this.$refs;
        refObj.limitSetting.setPolicyRef(this.editiongPolicy);
        refObj.passwordSetting.setPolicyRef(this.editiongPolicy);
        refObj.networkSetting.setPolicyRef(this.editiongPolicy);
        refObj.osSetting.setPolicyRef(this.editiongPolicy);
        refObj.googleAccountSetting?.setPolicyRef(this.editiongPolicy);
    }

    /**
     *  ポリシーJSON文字列をゲット
     */
    public getPolicyJsonText(): string {

        // ポリシー作成
        let outputPolicy = this.createPolicySetting();

        // 設定渡し
        return JSON.stringify(outputPolicy);
    }

    /**
     *  OKボタン押下時のチェック処理
     */
    public isApply(): boolean {

        // 子コンポーネントのチェック
        const refObj: any = this.$refs;
        let isApplyPasswordSetting = true;
        let isApplyOSSetting = refObj.osSetting.isApply();

        // 総合チェック
        let isApply = isApplyPasswordSetting && isApplyOSSetting;
        if (!isApply) {
            // 共通コンポーネントなのでエラー用のメッセージはここで出す
            let errorMessage = "設定した内容に不正な項目が存在するため、適用できません。<br />以下の設定内容を確認してください。";

            if (!isApplyPasswordSetting) {
                errorMessage += "<br />・画面ロック設定";
            }
            if (!isApplyOSSetting) {
                errorMessage += "<br />・システムアップデート設定";
            }

            MessageUtil.MessageBox(errorMessage, null, null, MessageUtil.MB_ICON_WARNING);

            // 適用できない
            return false;
        }

        // 適用できる
        return true;
    }

    /**
     *  ポリシーを作成する（Skyで管理している設定だけ取り込みたい）
     */
    private createPolicySetting(): AndroidPolicyWrapper {
        let setting = new AndroidPolicyWrapper();

        // Status reporting settings
        setting.policy.statusReportingSettings = new schema.AMAPI_StatusReportingSettings();
        // ApplicationReportは必ず取得する。
        setting.policy.statusReportingSettings.applicationReportsEnabled = true;

        // DeviceConnectivityManagement(この後の処理で送信用データとしての補正があるのでDeepCopyしている)
        setting.policy.deviceConnectivityManagement = cloneDeep(this.editiongPolicy.policy.deviceConnectivityManagement);

        // 制限設定
        setting.skypolicy.limitSettingEnabled = this.editiongPolicy.skypolicy.limitSettingEnabled;
        if (undefined != setting.skypolicy.limitSettingEnabled &&
            setting.skypolicy.limitSettingEnabled) {
            setting.policy.mountPhysicalMediaDisabled = this.editiongPolicy.policy.mountPhysicalMediaDisabled;
            // setting.policy.usbFileTransferDisabled = this.editiongPolicy.policy.usbFileTransferDisabled;	// un used old policy
            setting.policy.screenCaptureDisabled = this.editiongPolicy.policy.screenCaptureDisabled;
            setting.policy.smsDisabled = this.editiongPolicy.policy.smsDisabled;
            setting.policy.tetheringConfigDisabled = this.editiongPolicy.policy.tetheringConfigDisabled;
            setting.policy.bluetoothDisabled = this.editiongPolicy.policy.bluetoothDisabled;
            // setting.policy.credentialProviderPolicyDefault = this.editiongPolicy.policy.credentialProviderPolicyDefault;
            setting.policy.outgoingBeamDisabled = this.editiongPolicy.policy.outgoingBeamDisabled;
            setting.policy.factoryResetDisabled = this.editiongPolicy.policy.factoryResetDisabled;
            setting.policy.networkResetDisabled = this.editiongPolicy.policy.networkResetDisabled;
            setting.policy.addUserDisabled = this.editiongPolicy.policy.addUserDisabled;
            setting.policy.cameraAccess = this.editiongPolicy.policy.cameraAccess;
            setting.policy.autoDateAndTimeZone = this.editiongPolicy.policy.autoDateAndTimeZone;
            setting.policy.locationMode = this.editiongPolicy.policy.locationMode;
            setting.policy.stayOnPluggedModes = this.editiongPolicy.policy.stayOnPluggedModes;
            setting.policy.advancedSecurityOverrides = this.editiongPolicy.policy.advancedSecurityOverrides;
            setting.policy.accountTypesWithManagementDisabled = this.editiongPolicy.policy.accountTypesWithManagementDisabled;
            setting.policy.modifyAccountsDisabled = this.editiongPolicy.policy.modifyAccountsDisabled;
            setting.policy.privateKeySelectionEnabled = this.editiongPolicy.policy.privateKeySelectionEnabled;
        }
        else {
            /// 仕様変更や、その他の事情によるポリシーの変換処理
            /// ・ポリシーの仕様変更で廃止されたプロパティを代替プロパティに変換
            /// ・SKYSEAのバージョンアップなどで、AMAPIのデフォ値と異なる値を適用する
            setting.policy.privateKeySelectionEnabled = true;
            // OFFなら許可にする
            if (!setting.policy.deviceConnectivityManagement) setting.policy.deviceConnectivityManagement = new schema.AMAPI_DeviceConnectivityManagement();
            setting.policy.deviceConnectivityManagement.usbDataAccess = schemaConstants.AMAPI_UsbDataAccess_Enums.allowUsbDataTransfer;
        }

        // パスワード設定
        setting.skypolicy.passwordSettingEnabled = this.editiongPolicy.skypolicy.passwordSettingEnabled;
        if (undefined != setting.skypolicy.passwordSettingEnabled &&
            setting.skypolicy.passwordSettingEnabled) {
            setting.policy.passwordPolicies = this.editiongPolicy.policy.passwordPolicies;
            setting.policy.maximumTimeToLock = this.editiongPolicy.policy.maximumTimeToLock;
        }

        // ネットワーク設定
        setting.skypolicy.networkSettingEnabled = this.editiongPolicy.skypolicy.networkSettingEnabled;
        if (undefined != setting.skypolicy.networkSettingEnabled &&
            setting.skypolicy.networkSettingEnabled) {
            // setting.policy.wifiConfigDisabled = this.editiongPolicy.policy.wifiConfigDisabled;	// un used old policy
            setting.policy.dataRoamingDisabled = this.editiongPolicy.policy.dataRoamingDisabled;
            setting.policy.mobileNetworksConfigDisabled = this.editiongPolicy.policy.mobileNetworksConfigDisabled;
            setting.policy.vpnConfigDisabled = this.editiongPolicy.policy.vpnConfigDisabled;
            setting.policy.openNetworkConfiguration = this.editiongPolicy.policy.openNetworkConfiguration;
        }
        else {
            // OFFなら許可にする
            if (!setting.policy.deviceConnectivityManagement) setting.policy.deviceConnectivityManagement = new schema.AMAPI_DeviceConnectivityManagement();
            setting.policy.deviceConnectivityManagement.configureWifi = schemaConstants.AMAPI_ConfigureWifi_Enums.allowConfiguringWifi;
        }

        // OS設定
        setting.skypolicy.osSettingEnabled = this.editiongPolicy.skypolicy.osSettingEnabled;
        if (undefined != setting.skypolicy.osSettingEnabled &&
            setting.skypolicy.osSettingEnabled) {
            setting.policy.systemUpdate = this.editiongPolicy.policy.systemUpdate;
        }

        // Googleアカウント認証設定
        if (this.isManagedGoogleDomain) setting.policy.workAccountSetupConfig = this.editiongPolicy.policy.workAccountSetupConfig;
        else setting.policy.workAccountSetupConfig = undefined;

        return setting;
    }

    /**
     * 項目チェックボックスON/OFFハンドラ
     */
    public onSettingCheckButton(targetDialog: string, checked: boolean) {
        if (targetDialog === "limitSetting") {

            this.editiongPolicy.skypolicy.limitSettingEnabled = checked;
        }
        else if (targetDialog === "passwordSetting") {
            this.editiongPolicy.skypolicy.passwordSettingEnabled = checked;
        }
        else if (targetDialog === "networkSetting") {
            this.editiongPolicy.skypolicy.networkSettingEnabled = checked;
        }
        else if (targetDialog === "osSetting") {
            this.editiongPolicy.skypolicy.osSettingEnabled = checked;
        }
        this.$emit('notifyUpdate');
    }

    /**
     * 更新通知
     */
    private onNotifyUpdate(): void {
        this.$emit('notifyUpdate');
    }

    /**
     * 補足マニュアル
     */
    private limitSettingInformationHtml(): string {
        return "「開発者向けオプション」を利用する場合は、本設定を有効にして「開発者向けオプションを禁止する」のチェックを外してください。"
    }
    
    /**
     * 補足マニュアル
     */
    private ManagedGoogleDomainInformationHtml(): string {
        return "本設定は、すでにGoogleアカウントでログインしている端末には適用されません。<br />これらの端末に対して設定を適用したい場合は、端末をリセット（すべてのデータを消去）してください。"
    }
}

</script>

<style scoped>
/* アプリケーション管理部分のCSSはオンプレ版と同名のcssファイルを使用する */
</style>